import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./features/dashboard/Dashboard";
import LoginPage from "./features/login/LoginPage";
import ForgotPasswordPage from "./features/login/ForgotPasswordPage";
import RegistrationPage from "./features/registration/RegistrationPage";
import AppointmentsPage from "./features/appointments/AppointmentsPage";
import EncountersListPage from "./features/encounters/EncountersListPage";
import EncounterDetailPage from "./features/encounters/EncounterDetailPage";
import EncountersDebugPage from "./features/encounters/EncountersDebugPage";
import PatientsListPage from "./features/patients/PatientsListPage";
import PatientCreatePage from "./features/patients/PatientCreatePage";
import PatientDetailPage from "./features/patients/PatientDetailPage";
import PatientEditPage from "./features/patients/PatientEditPage";
import RecordingPage from "./features/scribe/recording/RecordingPage";
import ProtectedRoute from "./shared/components/ProtectedRoute";
import RegistrationApprovalsPage from "./features/admin/RegistrationApprovalsPage";
import TemplateManagementPage from "./features/admin/TemplateManagementPage";
import DoctorManagementPage from "./features/admin/DoctorManagementPage";
import AccountSettingsPage from "./features/profile/AccountSettingsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointments"
          element={
            <ProtectedRoute>
              <AppointmentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/encounters/debug"
          element={
            <ProtectedRoute>
              <EncountersDebugPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/encounters"
          element={
            <ProtectedRoute>
              <EncountersListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/encounters/:id"
          element={
            <ProtectedRoute>
              <EncounterDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/patients"
          element={
            <ProtectedRoute>
              <PatientsListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/patients/new"
          element={
            <ProtectedRoute>
              <PatientCreatePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/patients/:id"
          element={
            <ProtectedRoute>
              <PatientDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/patients/:id/edit"
          element={
            <ProtectedRoute>
              <PatientEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/patients/:id/record"
          element={
            <ProtectedRoute>
              <RecordingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/registrations"
          element={
            <ProtectedRoute adminOnly>
              <RegistrationApprovalsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <AccountSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/doctors"
          element={
            <ProtectedRoute adminOnly>
              <DoctorManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/templates"
          element={
            <ProtectedRoute adminOnly>
              <TemplateManagementPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
